import { render } from "./ic-arrow-range.vue?vue&type=template&id=a218b054"
import script from "./ic-arrow-range.vue?vue&type=script&lang=js"
export * from "./ic-arrow-range.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__